<!-- #3 -->
<template>
  <v-col class="mx-3">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 pb-0"
        style="color: #23468c; font-weight: 500"
      >
        List of Projection
      </div>
      <v-spacer></v-spacer>

      <v-btn
        color="primary"
        class="ml-2"
        v-if="checkPermission('app_pas:pas_projection_upload')"
        @click="$router.push('/pas-projection-create')"
        >Add/Edit Projection</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="Pas"
      :loading="loader"
      class="elevation-1 custom-icon-size"
      :options.sync="options"
      :server-items-length="total"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.updated_at`]="{ item }">
        {{ item.updated_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
        }}<br /><span v-if="item.updated_by">({{ item.updated_by }})</span>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">
          {{
            item.created_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
          }}</span
        ><br /><span v-if="item.created_by">({{ item.created_by }})</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span :class="item.status == 1 ? 'badge-active' : 'badge'">
          {{ item.status == 1 ? "Active" : "In-active" }}
        </span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom v-if="checkPermission('app_pas:pas_projection_edit')">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="edit(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row p-5 pr-1">
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="warehousees"
                  outlined
                  v-model="wms_warehouse_code"
                  dense
                  label="Warehouse"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="storers"
                  outlined
                  v-model="storer_id"
                  dense
                  label="Storer"
                  item-text="storer_name"
                  item-value="id"
                  multiple
                  v-bind:search-input.sync="searchText"
                  @change="clearSearchText"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="purposes"
                  outlined
                  v-model="purpose"
                  dense
                  chips
                  small-chips
                  label="Type"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="vehicles"
                  outlined
                  v-model="vehicle_type"
                  dense
                  label="Vehicle Type"
                  multiple
                  v-bind:search-input.sync="searchText"
                  @change="clearSearchText"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="Projected From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="Projected To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  :items="statuses"
                  outlined
                  v-model="status"
                  label="Status"
                  item-text="text"
                  item-value="value"
                  class="pb-0"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" sm="3" class="pl-0">
                <v-btn
                  color="white"
                  @click="clearAll"
                  style="float: right"
                  class="mr-2"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-2"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-2"></v-divider>
        </template>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  data: () => ({
    statuses: [
      { text: "Active", value: 1 },
      { text: "Inactive", value: 0 },
    ],
    searchText: "",
    status: null,
    forcePushed: false,
    loader: false,
    ShowToken: "",
    options: {},
    timelinePopup: false,
    trackingDetails: [],
    token_number: null,
    purpose: null,
    storer_id: [],
    active: null,
    storers: [],
    latest_event_status: null,
    from_date: null,
    to_date: null,
    dateMenuTo: false,
    dateMenu: false,
    summary: false,
    vehicle_type: [],
    purposes: [
      {
        text: "Inbound",
        value: 1,
      },
      {
        text: "Outbound",
        value: 2,
      },
      {
        text: "Both",
        value: 3,
      },
    ],
    tokenSummaryData: {
      payment_summary: {},
      order_details: {},
      shipping_address: {},
      billing_address: {},
    },
    headers: [
      {
        text: "Warehouse",
        value: "actual_warehouse",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Storer",
        value: "storer_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Type",
        value: "type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Vehicle Type",
        value: "vehicle_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "No of Vehicle",
        value: "no_of_vehicle",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Number of Pallet",
        value: "pallet_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Qty",
        value: "quantity",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Projection Date",
        value: "projection_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created At(By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated At(By)",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Action",
        value: "actions",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    Pas: [],
    warehousees: [],

    wms_warehouse_code: null,
    total: 0,
    vehicles: [],
    forceitem: {},
  }),

  created() {
    this.fetchStore();
    if (this.$store.getters.user.user_category == 4) {
      this.active = 1;
      this.allFilters();
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchPas();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getPasProjectionList",
      "snackBar",
      "pasTimeline",
      "fetchStorelist",
      "downloadPasData",
      "downloadPasTemplate",
      "forceCLoseApi",
    ]),
    clearSearchText() {
      this.searchText = ""; // Clears the search input after selection
    },
    edit(item) {
      this.$router.push({
        name: "PasProjectionCreate",
        query: { id: item.id },
      });
    },
    forcePushedFunction() {
      if (!this.$refs.form.validate()) return;

      if (this.rowcomment) {
        let payload = {
          id: this.forceitem.id,
          comments: this.rowcomment,
        };
        this.forceCLoseApi(payload)
          .then((res) => {
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.forcePushed = false;
            this.fetchPas();
          })
          .catch(() => {
            this.forcePushed = false;
          });
      }
    },
    fetchStore() {
      this.fetchStorelist().then((res) => {
        this.storers = res.data.storer;
        this.warehousees = res.data.warehouses.map(
          (obj) => Object.keys(obj)[0]
        );
        this.vehicles = res.data.vehicle_types;
      });
    },
    timeline(item) {
      this.ShowToken = item.token_number;
      this.pasTimeline(item.id).then((res) => {
        this.timelinePopup = true;
        this.trackingDetails = res.data;
      });
    },

    downloadpdf(path) {
      this.downloader = true;
      const parts = path.split("/");
      // The file name is the last part of the URL
      const fileName = parts[parts.length - 1];
      let url = `api/file_download?file_path=app_pas/upload_driver_declaration/${fileName}`;

      this.downloadPasTemplate(url)
        .then((res) => {
          this.fileDownload(res, "pdf");
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    findSummary(item) {
      this.getPasProjectionList({ id: item.id }).then((res) => {
        this.tokenSummaryData = res.data.records[0];
        this.summary = true;
      });
    },
    fetchPas() {
      this.loader = true;
      this.getPasProjectionList({
        ...this.filtersArr,
        ...this.options,
      })
        .then((res) => {
          this.loader = false;
          this.Pas = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    clearInput(val) {
      if (val == "this.from_date") {
        this.from_date = null;
      } else if (val == "this.to_date") {
        this.to_date = null;
      }
      if (val !== "") {
        val = "";
      }
    },
    clearAll() {
      this.token_number = null;
      this.purpose = null;
      this.storer_id = [];
      this.active = null;
      this.latest_event_status = null;
      this.to_date = null;
      this.from_date = null;
      this.wms_warehouse_code = null;
      this.vehicle_type = [];
      this.status = null;
      this.searchAll();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        status: this.status,
        type: this.purpose,
        storer_id: this.storer_id ? this.storer_id.join(",") : "",
        active: this.active,
        to_date: this.to_date,
        from_date: this.from_date,
        actual_warehouse: this.wms_warehouse_code,
        vehicle_type: this.vehicle_type ? this.vehicle_type.join(",") : "",
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    async searchAll() {
      this.options.page = 1;
      await this.allFilters();
      this.fetchPas();
    },
  },
};
</script>
<style lang="scss">
.v-btn--icon.v-size--default {
  height: 25px;
  width: 25px;
}
.p-0 {
  padding: 0px !important;
}

.layout.wrap.pt-3 {
  padding-left: 38px !important;
}
.card-title {
  padding-left: 22px;
}
.theme--light.v-data-table.custom-class
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  padding-left: 12px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.v-data-table.custom-class > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 48px;
  padding-left: 12px;
}
.tl-item {
  margin: 0;
  padding: 0;
}
.v-timeline
  cutom-timeline
  v-timeline--align-top
  v-timeline--dense
  theme--light::before {
  left: 13px !important;
  right: 25px !important;
  top: auto !important;
}
.custom-timeline .wrap {
  padding-left: 5px;
  padding-left: 0px;
}
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
  left: 9px !important;
  right: 25px !important;
  top: auto !important;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}

.mt {
  margin-top: 16px;
}
ul.tl li .item-detail {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
}
ul.tl li .timestamp {
  color: #8d8d8d;
  position: absolute;
  margin-left: -164px;
  text-align: right;
  font-size: 12px;
}
.history-tl-container-order {
  height: 55px;
  font-family: "Roboto", sans-serif;
  width: 60%;
  margin-left: 31%;
  display: block;
  position: relative;
  top: -3px;
}

.history-tl-container-order ul.tl {
  padding: 0;
  display: inline-block;
}
.history-tl-container-order ul.tl li {
  list-style: none;
  margin-left: 0;
  /*background: rgba(255,255,0,0.1);*/
  // border-left: 1px solid black;
  padding: 0 0 20px 20px;
  // position: relative;
  // height: 45px;
  line-height: 1px;
}

/* Container for the vertical line and icon */
.vertical-line {
  position: relative;
  display: inline-block;
  left: -30px;
  top: 12px;
}

/* Vertical line */
.vertical-line::before {
  content: "";
  position: absolute;
  top: 16px;
  left: 43%;
  transform: translateX(-50%);
  height: 43px;
  width: 1px;
  background-color: black;
}

/* Icon */
.icon {
  position: relative; /* Ensure the icon is in front of the line */
  font-size: 24px; /* Adjust icon size as needed */
  z-index: 1; /* Place the icon above the line */
}

.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 14px;
  text-align: center;
}
.badge-force {
  display: inline-block;
  padding: 4px 10px;
  background-color: orange;
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 12px;
  text-align: center;
}
</style>
